import credentials from "../../Config/credentials.config"

export const NaverHeader = () => {
    return {
        headers: {
            "X-NCP-APIGW-API-KEY-ID": credentials.naverClientID,
            "X-NCP-APIGW-API-KEY": credentials.naverSecretKey,
        }
    }
}